var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.24854 3.2751C8.09199 2.00993 9.51193 1.25 11.0325 1.25L12.9675 1.25C14.4881 1.25 15.908 2.00993 16.7515 3.2751C17.1998 3.94766 17.897 4.41455 18.6896 4.57307L18.8254 4.60023C21.1074 5.05663 22.75 7.06029 22.75 9.38747L22.75 13.2078L22.75 13.2506C22.75 14.9901 22.75 16.3536 22.6384 17.4386C22.5246 18.5453 22.2884 19.4461 21.7597 20.2261C21.3504 20.83 20.83 21.3504 20.2261 21.7597C19.4461 22.2884 18.5453 22.5246 17.4386 22.6384C16.3536 22.75 14.9901 22.75 13.2506 22.75L13.2078 22.75L10.7922 22.75L10.7494 22.75C9.00994 22.75 7.64641 22.75 6.56137 22.6384C5.45468 22.5246 4.55386 22.2884 3.77388 21.7597C3.17004 21.3504 2.64959 20.83 2.24031 20.2261C1.71164 19.4461 1.47539 18.5453 1.36158 17.4386C1.24999 16.3536 1.24999 14.9901 1.25 13.2507L1.25 13.2506L1.25 13.2078L1.25 9.38747C1.25 7.06029 2.89261 5.05663 5.1746 4.60023L5.31039 4.57307C6.103 4.41455 6.80017 3.94766 7.24854 3.2751ZM12 17C14.2091 17 16 15.2091 16 13C16 10.7909 14.2091 9 12 9C9.79086 9 8 10.7909 8 13C8 15.2091 9.79086 17 12 17Z",
    fill: "#0A213A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera1);
export default __webpack_public_path__ + "static/media/camera-1.af7ef434c2bf121cceb8cf528df8e0b5.svg";
export { ForwardRef as ReactComponent };